import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image10.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const SettingUpGameplayStep2 = () => (
  <Wrapper>
    <Container>
      <Text1>Setting Up Gameplay</Text1>
      <Text2>Length of the Simulation</Text2>
      <Text3>
        You'll first need to set the length of the simulation, which
        is <b>typically 4-5 weeks</b>. This comprises 4 rounds of the
        simulation (1 practice round, 3 main rounds) with each round
        typically lasting a week to give students time to review the
        data and meet with their team.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>

      <Text3>
        <b className="black-note">Note:</b> The <b>Game Admin</b> section is where
        you'll go to setup or modify rounds of the simulation.
      </Text3>
    </Container>
  </Wrapper>
);

export default SettingUpGameplayStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/setting-up-gameplay/step2.js